import React, { useEffect, useState } from "react";
import { formatAmountInLocale, goBackToEditNameScreen_extended } from "../../utils/global";

const PaymentScreenTopDiv = ({ loading, shopDetails, name, order_type, currentOrderData, splitAmountToBePaid, setName, setStep, id, superpay }) => {
  const open_singleProductDetailWhilePayingModal = () => {
    const singleProductDetailWhilePayingModal_element = document.getElementById('singleProductDetailWhilePayingModal');
    const singleProductDetailWhilePayingModal = new window.bootstrap.Modal(singleProductDetailWhilePayingModal_element);
    singleProductDetailWhilePayingModal.show();
  }

  const goBackToEditNameScreen = () => {
    setName("");

    setStep(0);

    goBackToEditNameScreen_extended(id);
  };

  useEffect(() => {
    const triggerTabList = document.querySelectorAll('#paymentTabs button[data-bs-toggle="tab"]');
    triggerTabList.forEach((triggerEl) => {
      new window.bootstrap.Tab(triggerEl);
    });
  }, []);

  return (
    <>
      <div className="text-center mb-3">
        <p className="text-color-amount-label">Amount to be paid</p>
        {!loading && <h4 className="text-color-amount-heading">{shopDetails.currency_with_symbol}{formatAmountInLocale(shopDetails.user_currency,splitAmountToBePaid)}</h4>}

        {order_type !== 'fixed_cart' && currentOrderData.cart_data.cart_display.length > 0 &&
          <>
            {currentOrderData.cart_data.cart_display[0]?.image_link && currentOrderData.cart_data.cart_display[0]?.description ? (
              <p className="note">
                <a className="darkGrayColor" onClick={open_singleProductDetailWhilePayingModal}>What am I paying for?</a>
              </p>
            ) : (
              <p className="note">Paying for: <b>{currentOrderData.cart_data.cart_display[0]?.name}</b></p>
            )}
          </>
        }
      </div>

      {name !== "" &&
        <div className="text-center mb-3">
          <p className="note">
            Welcome back <b>{name}</b> 👋
            &nbsp; | &nbsp;
            <a className="darkGrayColor" id="edit-name-link-button" onClick={goBackToEditNameScreen}>Edit name?</a>
          </p>
        </div>
      }

      {superpay === 'true' &&
        <div>
          <ul className="nav nav-pills nav-fill" id="paymentTabs" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pay-tab"
                data-bs-toggle="tab"
                data-bs-target="#payTab"
                type="button"
                role="tab"
                aria-controls="payTab"
                aria-selected="true"
              >
                Pay
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="share-tab"
                data-bs-toggle="tab"
                data-bs-target="#shareTab"
                type="button"
                role="tab"
                aria-controls="shareTab"
                aria-selected="false"
              >
                Share
              </button>
            </li>
          </ul>
        </div>
      }
    </>
  );
};

export default PaymentScreenTopDiv;
